export const MOS_REGEX =
  '(?<id>\\/[\\/A-Za-z0-9-_]{0,}?)(?<width>-[0-9]{0,5})?(?<quality>-[0-9]{2})?\\.(?<ext>png|jpg|jpeg|gif)(?<webp>.webp)?';

export const MISSING_IMAGE = '/media/img/missing-image.svg';

// These are default values but can be overwritten when calling the library.
export const SRCSETSIZES = [320, 640, 720, 1280];
export const SIZES = { default: '99vw' };
